import { DialogContent, DialogActions, Button } from "@mui/material";
import CommonDialog from "./CommonDialog";
import "./CommonDialog.css";

export default function AgreementDialog(props) {
	const { title, content, open, onClose, onAgree, canAgree, timeLeft, showAgree = true } = props;
	return (
		<CommonDialog
			open={open}
			onClose={onClose}
			title={title}
			customDialogContent={true}
			titleClassName="title-center"
		>
			<DialogContent className="agreement-dialog-content">
				<div dangerouslySetInnerHTML={{ __html: content }} />
			</DialogContent>
			<DialogActions className="agreement-dialog-footer">
				{showAgree && (
					<Button variant="contained" color="primary" onClick={onAgree} disabled={!canAgree}>
						Agree {!canAgree && timeLeft > 0 && timeLeft}
					</Button>
				)}

				<Button variant="contained" onClick={onClose}>
					Cancel
				</Button>
			</DialogActions>
		</CommonDialog>
	);
}
